import { GOOGLE_MAP_API_KEY } from "@/consts"
import {
    Geometry,
    GoogleGeocodingResults,
    GoogleGeocodingResult,
} from "@/models"
import axios, { AxiosResponse, AxiosError } from "axios"
import stringSimilarity from "string-similarity"

const API_ENDPOINT = `https://maps.googleapis.com/maps/api/geocode/json?key=${GOOGLE_MAP_API_KEY}`

const normalize = (address: string): string => {
    return address.trim().replace(/\s/g, "+")
}

const geodecode = (address: string): Promise<Geometry[]> => {
    const url = `${API_ENDPOINT}&address=${normalize(address)}`

    return new Promise((resolve, reject) => {
        axios
            .get(url)
            .then((resp: AxiosResponse<GoogleGeocodingResults>) => {
                const { status, results } = resp.data

                if (status === "OK" && results.length > 0) {
                    const sorted = results.sort(
                        (
                            a: GoogleGeocodingResult,
                            b: GoogleGeocodingResult
                        ) => {
                            const similarityA = stringSimilarity.compareTwoStrings(
                                a.formatted_address,
                                address
                            )

                            const similarityB = stringSimilarity.compareTwoStrings(
                                b.formatted_address,
                                address
                            )

                            return similarityA > similarityB ? -1 : 1
                        }
                    )

                    return resolve(
                        sorted.map((x: GoogleGeocodingResult) => x.geometry)
                    )
                } else {
                    return resolve([])
                }
            })
            .catch((err: AxiosError) => {
                reject(err)
            })
    })
}

export default geodecode
